import { render, staticRenderFns } from "./Accesses.vue?vue&type=template&id=6e463f66&"
import script from "./Accesses.vue?vue&type=script&lang=ts&"
export * from "./Accesses.vue?vue&type=script&lang=ts&"
import style0 from "./Accesses.vue?vue&type=style&index=0&id=6e463f66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports